'use strict';
import $ from 'jquery';
import { v4 as uuidv4 } from 'uuid';
import 'slick-carousel';

export default class M32 {
  static init() {
    $('.module-m32').each((index, el) => {
      new M32($(el));
    });
  }

  constructor($el) {
    this.el = $el;
    if (!this.el.attr('id')) {
      this.el.attr('id', 'module-m32-' + uuidv4());
    }
    if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
      this.el.find('.modal-dialog').css('-webkit-overflow-scrolling', 'touch');
    } else {
      this.el.find('.modal-dialog').css('overflow-y', 'scroll');
    }
    // let popup = this.el.find('.module-m32-modal').detach();
    // popup.attr('id', this.el.attr('id') + '-modal');
    // $('body').append(popup);

    this.el.find('.module-m32-employee a.module-m32-employee-link').on('click', this.showPopup.bind(this));
  }

  showPopup(e) {
    e.preventDefault();
    const self = this;
    const slide = $(e.currentTarget).data('slide');
    let popup = this.el.find('.module-m32-modal').clone();

    if (popup.find('.slick-initialized').length === 0) {
      console.log('dots: ', self.el.find('.dots'));
      popup.find('.modal-slick').slick({
        arrows: true,
        // dots: true,
        initialSlide: slide,
        // appendDots: self.el.find('.dots'),
        appendArrows: popup.find('.arrows'),
      });
    } else {
      popup.find('.modal-slick').slick('slickGoTo', slide);
    }
    popup.on('hidden.bs.modal', (e) => {
      console.log('modal hidden');
      popup.remove();
    });
    popup.modal();
  }
}
